// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content/TreatmentSelect/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New_PatientOptions_Existing_Content_TreatmentSelect_Content($patient_id: uuid!, $location_id: uuid!) {
  treatments_create_treatment(
    args: { _patient_id: $patient_id, _location_id: $location_id }
  ) {
    _id
  }
}

`